import { BlockVariant, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { Injectable } from '@angular/core';

interface getPreDraftBlocksProps {
  save?: () => void;
  rest?: () => void;
}

interface getDraftBlocksProps {
  save?: () => void;
  rest?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class DynamicFormsWorkflowBlocksService {
  getPreDraftBlocks = ({ save, rest }: getPreDraftBlocksProps): DynamicBlocks => {
    const saveButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Enregistrer',
        onClick: () => save?.(),
      },
    };
    const resetButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Réinitialiser',
        onClick: rest,
        severity: 'secondary',
      },
    };
    return {
      '1': [saveButton],
      '2': [resetButton],
    };
  };

  getDraftBlocks = ({ save, rest }: getDraftBlocksProps): DynamicBlocks => {
    const saveButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Enregistrer',
        onClick: () => save?.(),
      },
    };
    const resetButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Réinitialiser',
        onClick: rest,
        severity: 'secondary',
      },
    };
    return {
      '1': [saveButton],
      '2': [resetButton],
    };
  };
}
